import { render, staticRenderFns } from "./IncidentTypes.v2.vue?vue&type=template&id=73bf3d08&"
import script from "./IncidentTypes.v2.vue?vue&type=script&lang=js&"
export * from "./IncidentTypes.v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports